// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 160 160\"><path d=\"M110.8,119.8H55a22.8,22.8,0,0,1,0-45.5l3.2.3a31.6,31.6,0,0,1,60.2,10.7,18.1,18.1,0,0,1-7.6,34.5ZM55,76.3a20.8,20.8,0,0,0,0,41.5h55.8A16.1,16.1,0,0,0,117,86.9a1.5,1.5,0,0,1-.6-.9,29.6,29.6,0,0,0-56.7-9.9,1.1,1.1,0,0,1-1.1.6A15.3,15.3,0,0,0,55,76.3Z\"/></svg>";
// Exports
module.exports = code;